/* jshint esversion: 6, -W097 */
/* globals require, module */
'use strict';

const getFetchModule = require('@utils/get_fetch/getFetchModule');
const GeoService = require('./geoService');

const geoModule = angular
    .module('enervee_utils.geo', [
        getFetchModule.name,
    ])
    .factory('GeoService', GeoService);

module.exports = geoModule;